import { ValidationProblemDetails } from 'performo-api';
import store from './store';

export async function handleApiError(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: ValidationProblemDetails | Response | any
): Promise<boolean> {
  if (!error) {
    return false;
  }

  // handle the case when there is a server error
  if (error.status === 500) {
    store.commit('setError', {
      description:
        'A server error occurred, please try again in a moment. Contact support if the issue persists.'
    });
    return true;
  }

  // handle the case when there is a Forbidden response
  if (error.status === 403) {
    store.commit('setError', {
      description: 'You do not have permission to perform that action.'
    });
    return true;
  }

  // handle the case when we get a non-500 error, which maybe a ValidationProblemDetails instance which has additional information we can try to display.
  let vpd: ValidationProblemDetails;
  if (error instanceof Response) {
    vpd = await error.json();
  } else {
    vpd = error;
  }

  if (vpd.errors) {
    store.commit('setError', {
      title: vpd.title,
      description:
        vpd.errors[Object.keys(vpd.errors)[0]][0] || 'An error occurred.'
    });
    return true;
  }

  store.commit('setError', {
    title: 'An error occurred.',
    description:
      'An error occurred. Please try again in a moment. Contact support if the issue persists.'
  });
  return true;
}
